import { Routes, Route } from 'react-router-dom';
import ApprovalInstanceView from './pages/approvals/ApprovalInstanceView';
import ApprovalInstanceListViewer from './pages/approvals/ApprovalInstanceListViewer';
import MyApprovals from './pages/myApprovals/MyApprovals';
import ApprovalTemplateList from './pages/approvalTemplates/ApprovalTemplateList';
import ApprovalTemplateForm from './pages/approvalTemplates/ApprovalTemplateForm';
import ApprovalTemplateDetail from './pages/approvalTemplates/ApprovalTemplateDetail';
import SubmitApprovalDialog from './pages/approvals/SubmitApprovalDialog';

function ApprovalRoutes() {
  return (
    <Routes>
      {/* Unified My Approvals inbox (dynamic tabs from registered entity types) */}
      <Route path="my-approvals" element={<MyApprovals />} />

      {/* Approval Instance Viewer (generic for any module/object) */}
      <Route path="instance/:instanceId" element={<ApprovalInstanceView />} />

      {/* Approval Instance List Viewer */}
      <Route path="pending" element={<ApprovalInstanceListViewer />} />

      {/* Approval Templates */}
      <Route path="approval-templates" element={<ApprovalTemplateList />} />
      <Route path="approval-templates/create" element={<ApprovalTemplateForm />} />
      <Route path="approval-templates/:id/edit" element={<ApprovalTemplateForm />} />
      <Route path="approval-templates/:id" element={<ApprovalTemplateDetail />} />

      {/* Approval Submission Dialog (can be used as a page for demo) */}
      <Route path="submit-approval" element={<SubmitApprovalDialog visible={true} />} />

      {/* Default route: could show template list or instance list */}
      <Route path="/rules" element={<ApprovalTemplateList />} />
    </Routes>
  );
}

export default ApprovalRoutes;
